import {aumra} from '../defaults/.url'
import {urls} from '../urls'
export const amuraService = urls.developmentUrl + ':9000/v1/'
export const settingsService = urls.developmentUrl +':5018'

export const userUrls = {
  postUser: amuraService + 'signup',
  postGuestUser: amuraService + 'guest/signup',
  postPartnerUser: amuraService + 'partner/user',
  getUsers: aumra + 'users/institution/',
  getPartnerUsers: amuraService + 'users/institution/',
  getUser: amuraService + 'user/',
  getUserByEmail: amuraService + 'user/by-email/',
  deleteUser: amuraService + 'user/delete/',
  editUser: amuraService + 'user/update/',
  getAllUsers: amuraService + 'users',
  restoreUser: amuraService + 'starts/restore/',
  getDeletedUser: amuraService + 'starts/deleted',
  suspendUser: amuraService + 'user/suspend/',
  unsuspendUser: amuraService + 'user/unsuspend/',
  getAllPublicUsers: amuraService + 'public_users',

    // Wallet endpoints 
  getWalletBalance: amuraService + 'wallet/balance/',
  getWalletTransactions: amuraService + 'wallet/transactions/',
  getWalletTransaction: amuraService + 'wallet/transaction/',
  walletDeposit: amuraService + 'wallet/deposit',
  walletPayment: amuraService + 'wallet/payment',
  walletRefund: amuraService + 'wallet/refund',
  getBookingWalletTransactions: amuraService + 'wallet/transactions/booking/',
  getUserWalletDeposits: amuraService + 'wallet/deposits/',

    // M-Pesa Payment endpoints
  mpesaPayment: amuraService + 'bookings/payment/mpesa/new',
  mpesaCallback: amuraService + 'mpesa/callback',
  mpesaStatus: amuraService + 'mpesa/status/',
  
  // iVeri Payment endpoints
  iveriPayment: amuraService + 'iveri/payment/initiate',
  iveriDonation: amuraService + 'iveri/donation',
 
}

export const userTypeUrls = {
  postUserType: amuraService + 'add/usertype',
  getUserTypes: amuraService + 'usertypes',
  getUserType: amuraService + 'single/usertype/',
  getUserTypeFeatures: amuraService + 'features/role/',
  getNotAssignedFeatures: amuraService + 'feature/notassigned/',
  deleteUserType: amuraService + 'delete/usertype/',
  editUserType: amuraService + 'update/usertype/',
  getAllUserTypes: amuraService + 'usertypes',
  restoreUserType: amuraService + 'starts/restore/',
  getDeletedUserType: amuraService + 'starts/deleted'
}

export const menuUrls = {
  postMenu: amuraService + 'menu/add',
  getMenus: amuraService + 'menus',
  getMenu: amuraService + 'menu/',
  deleteMenu: amuraService + 'starts/delete/',
  editMenu: amuraService + 'menu/update/',
  getAllMenus: amuraService + 'menus',
  restoreMenu: amuraService + 'starts/restore/',
  getDeletedMenu: amuraService + 'starts/deleted'
}

export const featureUrls = {
  assignFeature: amuraService + 'role/feature/add',
  removeFeature: amuraService + 'role/feature/detach',
  postFeature: amuraService + 'feature/add',
  getFeatures: amuraService + 'features',
  getFeature: amuraService + 'starts/single/',
  deleteFeature: amuraService + 'starts/delete/',
  editFeature: amuraService + 'starts/edit/',
  getAllFeatures: amuraService + 'features',
  restoreFeature: amuraService + 'starts/restore/',
  getDeletedFeature: amuraService + 'starts/deleted'
}

export const countryUrls = {
  postCountry: amuraService + 'post',
    getAllCountries: amuraService + 'countries',
  getCountry: amuraService + 'get_single',
  editCountry: amuraService + 'update',
  deleteCountry: amuraService + 'delete'
}

export const genderUrl = {
  getAllGenders: amuraService + 'genders',
  getAllGenders2: amuraService + 'genders/schools'
}
